var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found"},[_c('div',{staticClass:"not-found-inner h-wrapper"},[_c('div',{staticClass:"not-found__headline headline--light"},[_vm._v("Page introuvable")]),_c('img',{staticClass:"not-found__picture",attrs:{"src":require("@/assets/images/notfound.png"),"alt":"notfoundlogo"}}),_c('g-btn',{attrs:{"btn":{
        title: 'Vers la page d\'accueil',
        url: { name: 'home', params: { lang: _vm.currentLang } },
        icon: {
          slug: 'ui-arrow-right',
        },
      }}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }